export default "__VITE_ASSET__ChCW5kYp__"